import * as React from 'react';
import { Button, FormGroup, Input, Row } from 'reactstrap';
import { Svg } from 'src/components/shared/Svg';
import {
  IGlobalContextProps,
  withGlobalContext,
} from 'src/context/global.context';
import { IMessage, IProposition, IUser } from 'src/model';
import { sendMessage } from 'src/services';
import { WorkspaceMessage } from './WorkspaceMessage';

interface IWorkspaceMessageListProps {
  client: IUser;
  consultant: IUser;
  messageList: IMessage[];
  proposition: IProposition;
}

const WorkspaceMessageList: React.SFC<
  IWorkspaceMessageListProps & IGlobalContextProps
> = (props) => {
  const { client, consultant, proposition } = props;
  const { user } = props.context;
  const [state, setState] = React.useState({
    messageList: [...props.messageList],
    text: '',
  });
  const receiver = user && user._id === client._id ? consultant : client;
  const sender = user && user._id === client._id ? client : consultant;

  const handleChange = (e: React.ChangeEvent<Element>) => {
    setState({
      ...state,
      text: (e.target as any).value,
    });
  };

  const handleSubmit = async () => {
    const newMessage = {
      receiver: receiver._id,
      sender: sender._id,
      text: state.text,
    };
    const newProposition = await sendMessage(proposition._id, newMessage);
    if (newProposition) {
      setState({
        messageList: newProposition.messageList,
        text: '',
      });
    }
  };

  return (
    <>
      <Row className='d-flex align-items-center'>
        <Svg width={48} fill='dark' src='chat' />
        <h4 className='text-uppercase text-dark ml-4'>{`échanges avec ${user &&
          user.firstname}`}</h4>
      </Row>
      <Row
        className='message-list mt-3'
        style={{ maxHeight: '300px', overflow: 'scroll' }}
      >
        {state.messageList.map((message: IMessage, key: number) => (
          <WorkspaceMessage
            key={key}
            message={message}
            receiver={receiver}
            sender={sender}
          />
        ))}
      </Row>
      <Row>
        <FormGroup className='w-100 mt-3'>
          <Input
            type='textarea'
            name='title'
            placeholder='Votre message'
            value={state.text}
            onChange={handleChange}
            style={{ minHeight: '80px' }}
          />
          <Button
            className='float-right text-uppercase text-white mt-3'
            onClick={handleSubmit}
          >
            Envoyer
          </Button>
        </FormGroup>
      </Row>
    </>
  );
};

export const WorkspaceMessageListWithGlobalContext = withGlobalContext(
  WorkspaceMessageList
);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectWorkspace/WorkspaceMessageList/WorkspaceMessageList.tsx